import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExpedientesWizardComponent} from './componentes/expedientes-wizard/expedientes-wizard.component';
import {WizardModule} from "../wizard/wizard.module";
import {ExpedientesPageComponent} from './componentes/expedientes-page/expedientes-page.component';
import {MatIconModule} from "@angular/material/icon";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatTableModule} from "@angular/material/table";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatButtonModule} from "@angular/material/button";
import {FlexLayoutModule, FlexModule} from "@angular/flex-layout";
import {ExpedientesCreateComponent} from './componentes/expedientes-create/expedientes-create.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {MatMenuModule} from "@angular/material/menu";
import {
    ActualizacionDialogComponent
} from './componentes/sub-components/actualizacion-dialog/actualizacion-dialog.component';
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatChipsModule} from '@angular/material/chips';
import {FolioDialogComponent} from './componentes/dialogs/folio/folio-dialog.component';
import {MatRadioModule} from '@angular/material/radio';
import {SwiperModule} from 'swiper/angular';
import {CardFlipComponent} from './core/components/card-flip/card-flip.component';
import {EvkContentModule} from "@evomatik/evk-content";
import {MatBadgeModule} from '@angular/material/badge';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MAT_DATE_LOCALE, MatNativeDateModule} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {ReqDialogComponent} from './componentes/dialogs/req-dialog/req-dialog.component';
import {
    UploapFileExpedienteComponent
} from './componentes/sub-components/upload-file-expediente/uploap-file-expediente.component';
import {PrestacionSocialPageComponent} from './componentes/prestacion-social-page/prestacion-social-page.component';
import {DetallePrestacionComponent} from './componentes/sub-components/detalle-prestacion/detalle-prestacion.component';
import {MatTabsModule} from "@angular/material/tabs";
import {
    DatosBeneficiarioComponent
} from './componentes/sub-components/detalle-prestacion/datos-beneficiario/datos-beneficiario.component';
import {
    DatosLocalizacionComponent
} from './componentes/sub-components/detalle-prestacion/datos-localizacion/datos-localizacion.component';
import {
    DatosProgramaComponent
} from './componentes/sub-components/detalle-prestacion/datos-programa/datos-programa.component';
import {
    DatosEntregaComponent
} from './componentes/sub-components/detalle-prestacion/datos-entrega/datos-entrega.component';
import {
    DatosGeoreferenciaComponent
} from './componentes/sub-components/detalle-prestacion/datos-georeferencia/datos-georeferencia.component';
import {MatListModule} from '@angular/material/list';

@NgModule({
    declarations: [
        ExpedientesWizardComponent,
        ExpedientesPageComponent,
        ExpedientesCreateComponent,
        ActualizacionDialogComponent,
        FolioDialogComponent,
        CardFlipComponent,
        ReqDialogComponent,
        UploapFileExpedienteComponent,
        PrestacionSocialPageComponent,
        DetallePrestacionComponent,
        DatosBeneficiarioComponent,
        DatosLocalizacionComponent,
        DatosProgramaComponent,
        DatosEntregaComponent,
        DatosGeoreferenciaComponent
    ],
    imports: [
        CommonModule,
        WizardModule,
        MatInputModule,
        MatIconModule,
        MatCardModule,
        MatPaginatorModule,
        MatTableModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatButtonModule,
        FlexModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatSelectModule,
        MatMenuModule,
        MatToolbarModule,
        MatDialogModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        FormsModule,
        MatChipsModule,
        MatRadioModule,
        SwiperModule,
        MatBadgeModule,
        MatTooltipModule,
        EvkContentModule,
        MatProgressSpinnerModule,
        MatNativeDateModule,
        ReactiveFormsModule,
        MatTabsModule,
        MatListModule
    ],
    exports: [
        ExpedientesWizardComponent,
        ExpedientesPageComponent,
        ExpedientesCreateComponent,
        PrestacionSocialPageComponent
    ],
    entryComponents: [
        UploapFileExpedienteComponent
    ],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'es-MX'},
        {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: 'es-MX'}
    ]
})
export class ExpedienteModule {
}
